import React from "react";
import { Resource } from "react-admin";
import NotificationsIcon from "@material-ui/icons/Email";
import PermissionDenied from "../../components/PermissionDenied";
import { POLICY_NOTIFICATIONS } from "../../common/rolesManagement";

import List from "./List";
export default permissions => (
    <Resource
        name="notifications"
        icon={NotificationsIcon}
        list={
            permissions &&
            permissions.includes(POLICY_NOTIFICATIONS.SEND_NOTIFICATIONS)
                ? List
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/Notifications/index.js